export interface Quote {
  id: string;
  text: string;
  author?: string;
}

export const DEFAULT_QUOTES: Quote[] = [
  {
    id: '1',
    text: 'The present moment is the only time over which we have dominion.',
    author: 'Thich Nhat Hanh'
  },
  {
    id: '2',
    text: 'In the beginner\'s mind there are many possibilities, in the expert\'s mind there are few.',
    author: 'Shunryu Suzuki'
  },
  {
    id: '3',
    text: 'Wherever you are, be there totally.',
    author: 'Eckhart Tolle'
  },
  {
    id: '4',
    text: 'The best camera is the one that\'s with you.',
    author: 'Chase Jarvis'
  },
  {
    id: '5',
    text: 'You don\'t take a photograph, you make it.',
    author: 'Ansel Adams'
  },
  {
    id: '6',
    text: 'Be yourself; everyone else is already taken.',
    author: 'Oscar Wilde'
  },
  {
    id: '7',
    text: 'The journey of a thousand miles begins with one step.',
    author: 'Lao Tzu'
  },
  {
    id: '8',
    text: 'Peace comes from within. Do not seek it without.',
    author: 'Buddha'
  },
  {
    id: '9',
    text: 'What we think, we become.',
    author: 'Buddha'
  },
  {
    id: '10',
    text: 'The only way to do great work is to love what you do.',
    author: 'Steve Jobs'
  },
  {
    id: '11',
    text: 'Beauty is everywhere. You only have to look to see it.',
    author: 'Bob Ross'
  },
  {
    id: '12',
    text: 'Simplicity is the ultimate sophistication.',
    author: 'Leonardo da Vinci'
  },
  {
    id: '13',
    text: 'The moment you doubt whether you can fly, you cease forever to be able to do it.',
    author: 'J.M. Barrie'
  },
  {
    id: '14',
    text: 'Life is a journey, not a destination.',
    author: 'Ralph Waldo Emerson'
  },
  {
    id: '15',
    text: 'Happiness is not something ready made. It comes from your own actions.',
    author: 'Dalai Lama'
  },
  {
    id: '16',
    text: 'The quieter you become, the more you can hear.',
    author: 'Ram Dass'
  },
  {
    id: '17',
    text: 'Every moment is a fresh beginning.',
    author: 'T.S. Eliot'
  },
  {
    id: '18',
    text: 'Nature does not hurry, yet everything is accomplished.',
    author: 'Lao Tzu'
  },
  {
    id: '19',
    text: 'The best time to plant a tree was 20 years ago. The second best time is now.',
    author: 'Chinese Proverb'
  },
  {
    id: '20',
    text: 'You are the sky. Everything else is just weather.',
    author: 'Pema Chödrön'
  },
  {
    id: '21',
    text: 'Photography is a way of feeling, of touching, of loving. What you have caught on film is captured forever.',
    author: 'Aaron Siskind'
  },
  {
    id: '22',
    text: 'A photograph is a secret about a secret. The more it tells you, the less you know.',
    author: 'Diane Arbus'
  },
  {
    id: '23',
    text: 'The camera is an instrument that teaches people how to see without a camera.',
    author: 'Dorothea Lange'
  },
  {
    id: '24',
    text: 'When words become unclear, I shall focus with photographs. When images become inadequate, I shall be content with silence.',
    author: 'Ansel Adams'
  },
  {
    id: '25',
    text: 'To me, photography is an art of observation. It\'s about finding something interesting in an ordinary place.',
    author: 'Elliott Erwitt'
  },
  {
    id: '26',
    text: 'The earth has music for those who listen.',
    author: 'George Santayana'
  },
  {
    id: '27',
    text: 'Look deep into nature, and then you will understand everything better.',
    author: 'Albert Einstein'
  },
  {
    id: '28',
    text: 'In every walk with nature, one receives far more than he seeks.',
    author: 'John Muir'
  },
  {
    id: '29',
    text: 'The mountains are calling and I must go.',
    author: 'John Muir'
  },
  {
    id: '30',
    text: 'Adopt the pace of nature: her secret is patience.',
    author: 'Ralph Waldo Emerson'
  },
  {
    id: '31',
    text: 'The sun does not forget a village just because it is small.',
    author: 'African Proverb'
  },
  {
    id: '32',
    text: 'Let yourself be silently drawn by the strange pull of what you really love. It will not lead you astray.',
    author: 'Rumi'
  },
  {
    id: '33',
    text: 'Yesterday I was clever, so I wanted to change the world. Today I am wise, so I am changing myself.',
    author: 'Rumi'
  },
  {
    id: '34',
    text: 'The wound is the place where the Light enters you.',
    author: 'Rumi'
  },
  {
    id: '35',
    text: 'What lies behind us and what lies before us are tiny matters compared to what lies within us.',
    author: 'Ralph Waldo Emerson'
  },
  {
    id: '36',
    text: 'The only person you are destined to become is the person you decide to be.',
    author: 'Ralph Waldo Emerson'
  },
  {
    id: '37',
    text: 'Do not dwell in the past, do not dream of the future, concentrate the mind on the present moment.',
    author: 'Buddha'
  },
  {
    id: '38',
    text: 'Three things cannot be long hidden: the sun, the moon, and the truth.',
    author: 'Buddha'
  },
  {
    id: '39',
    text: 'We are what we think. All that we are arises with our thoughts. With our thoughts, we make the world.',
    author: 'Buddha'
  },
  {
    id: '40',
    text: 'The mind is everything. What you think you become.',
    author: 'Buddha'
  },
  {
    id: '41',
    text: 'If you want to fly, give up everything that weighs you down.',
    author: 'Buddha'
  },
  {
    id: '42',
    text: 'The way is not in the sky. The way is in the heart.',
    author: 'Buddha'
  },
  {
    id: '43',
    text: 'Peace cannot be kept by force; it can only be achieved by understanding.',
    author: 'Albert Einstein'
  },
  {
    id: '44',
    text: 'The most beautiful thing we can experience is the mysterious.',
    author: 'Albert Einstein'
  },
  {
    id: '45',
    text: 'Creativity is intelligence having fun.',
    author: 'Albert Einstein'
  },
  {
    id: '46',
    text: 'The only real valuable thing is intuition.',
    author: 'Albert Einstein'
  },
  {
    id: '47',
    text: 'A person who never made a mistake never tried anything new.',
    author: 'Albert Einstein'
  },
  {
    id: '48',
    text: 'Imagination is more important than knowledge.',
    author: 'Albert Einstein'
  },
  {
    id: '49',
    text: 'The future belongs to those who believe in the beauty of their dreams.',
    author: 'Eleanor Roosevelt'
  },
  {
    id: '50',
    text: 'You must be the change you wish to see in the world.',
    author: 'Mahatma Gandhi'
  }
];
